// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import RatingStars from 'app/packages/recipe-star-components/RatingStars';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { Box, Text } from 'gestalt';

const RATING_STAR_SIZE = 16;

type Props = {
  pin: ?Object,
  recipe: ?Object,
  ratingStarSize?: number,
  isInPinGrid?: boolean,
  isShowReviewText?: boolean,
};

const PinLandingRecipeRating = ({
  pin,
  recipe,
  isInPinGrid = false,
  isShowReviewText = true,
  ratingStarSize = RATING_STAR_SIZE,
}: Props) => {
  if (!pin || !recipe) {
    return null;
  }

  const review_count =
    pin.rich_metadata.recipe.aggregate_rating &&
    pin.rich_metadata.recipe.aggregate_rating.review_count;

  if (!review_count || review_count < 1) {
    return null;
  }

  return (
    <Box display="flex" alignItems="center">
      {pin.rich_metadata &&
        pin.rich_metadata.recipe &&
        pin.rich_metadata.recipe.aggregate_rating && (
          <RatingStars
            rating={pin.rich_metadata.recipe.aggregate_rating.rating_value}
            max_rating={pin.rich_metadata.recipe.aggregate_rating.best_rating}
            width={ratingStarSize}
            color="yellow"
          />
        )}
      <Box marginLeft={1} marginTop={isInPinGrid ? 0 : 1}>
        <Text bold={!isInPinGrid} size={isInPinGrid ? 'sm' : 'md'}>
          {isShowReviewText
            ? interpolateNamedTemplate(
                i18n.ngettext('{{review_count}} review', '{{review_count}} reviews', review_count),
                { review_count },
              )
            : interpolateNamedTemplate(
                i18n.ngettext('{{review_count}}', '{{review_count}}', review_count),
                { review_count },
              )}
        </Text>
      </Box>
    </Box>
  );
};

export default PinLandingRecipeRating;
